/* Trial B: reconcile only request-marked gifts. Checkout enforcement belongs to the backend. */
(function () {
  'use strict';
  if (window.alTrialGiftLifecycle) return;
  var config = window.AL_TRIAL_GIFTS_B_CART;
  if (!config || !Array.isArray(config.parents) || !config.gifts) return;
  var nativeFetch = window.fetch;
  var header = 'X-AL-Trial-Gift-Sync';
  var active = null, timer = null, queued = false, inflight = 0, leaseRetries = 0, mutationGeneration = 0;
  var pending = true, error = '', uncertain = false, relevant = false, inspected = false, invalidPriceLock = false;
  var ownHeaders = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-AL-Trial-Merge': '1', 'X-AL-Trial-Gift-Sync': '1' };
  var id = function (value) { return String(value == null ? '' : value); };
  var planId = function (line) { return id(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id); };
  var marker = function (line) { return line.properties && line.properties._trial_gift_request; };
  var owned = function (line) { return Boolean(marker(line) && line.properties._trial_gift_for); };
  var safeId = function (value) { return /^[1-9]\d*$/.test(id(value)) && Number.isSafeInteger(Number(value)); };
  var fail = function (message) { throw new Error(message); };
  var status = function () { return { pending: pending, error: error, uncertain: uncertain, relevant: relevant, running: Boolean(active), inflight: inflight }; };

  function mergeBlocked() { return Boolean(window.alTrialCartMerge && window.alTrialCartMerge.transactionBlocked); }
  var checkoutNoticeRequested = false;
  function mergeNotice() { return checkoutNoticeRequested && checkoutBlocked() || mergeFailed() || Boolean(window.alTrialCartMerge && window.alTrialCartMerge.transactionInspected && mergeBlocked()); }
  function mergeFailed() { return Boolean(window.alTrialCartMerge && window.alTrialCartMerge.transactionFailed); }
  function render() {
    var notice = document.getElementById('al-trial-gift-lifecycle-status');
    if (!notice && document.body) {
      notice = document.createElement('div');
      notice.id = 'al-trial-gift-lifecycle-status';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.style.cssText = 'position:fixed;left:12px;right:12px;top:12px;z-index:2147483000;margin:auto;max-width:560px;padding:12px 16px;background:#fff5ef;color:#442c34;border:1px solid #b74f5e;border-radius:8px;font-size:14px;line-height:1.5;box-shadow:0 2px 10px #0002';
      document.body.appendChild(notice);
    }
    if (!notice) return;
    document.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .dynamic-checkout__content').forEach(function(node){if(mergeBlocked()){if(!node.hasAttribute('data-al-merge-hidden')){node.setAttribute('data-al-merge-hidden',node.hidden?'1':'0');}if(!node.hidden) node.hidden=true;}else if(node.hasAttribute('data-al-merge-hidden')){node.hidden=node.getAttribute('data-al-merge-hidden')==='1';node.removeAttribute('data-al-merge-hidden');}});
    notice.hidden = !(mergeNotice() || relevant && (pending || error) || !inspected && error);
    notice.textContent = mergeFailed() ? 'カートの変更結果を確認できませんでした。再追加せず、ページを再読み込みしてカートをご確認ください。解決しない場合は、お問い合わせください。' : error === 'Multiple trial parents share a gift request' ? 'カートの表示が最新ではない可能性があります。ページを再読み込みし、8日間と16日間のお試しセットの組み合わせをご確認ください。解決しない場合は、お問い合わせください。' : error ? '無料ギフトの内容を確認できませんでした。お支払いに進む前にカートをご確認ください。ページを再読み込みしても解決しない場合は、お問い合わせください。' : '無料ギフトを確認しています。少々お待ちください。';
    notice.setAttribute('role', error || mergeFailed() ? 'alert' : 'status');
  }
  function request(path, body) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
    var init = { credentials: 'same-origin', cache: 'no-store', headers: ownHeaders, signal: controller.signal };
    if (body) { init.method = 'POST'; init.body = JSON.stringify(body); }
    return nativeFetch.call(window, path, init).then(function (response) {
      if (!response.ok) fail('Cart request rejected: ' + response.status);
      return response.json();
    }).finally(function () { window.clearTimeout(timeout); });
  }
  function readCart() {
    return request('/cart.js').then(function (cart) {
      if (cart.currency !== 'JPY' || !Array.isArray(cart.items)) fail('Unverified cart');
      return cart;
    });
  }
  function relevantCart(cart) {
    return cart.items.some(function (line) {
      return Boolean(marker(line) && (owned(line) || id(line.product_id) === id(config.productId) && config.parents.some(function (parent) { return id(parent.variantId) === id(line.variant_id); })));
    });
  }
  function checkoutBlocked() { return mergeBlocked() || Boolean(window.alTrialMainCartFailed) || !inspected || relevant && (pending || error); }
  function analyse(cart) {
    var groups = {}, result = { operation: null, relevant: false };
    cart.items.forEach(function (line) {
      var token = marker(line);
      if (!token) return;
      var rule = config.parents.filter(function (parent) { return id(parent.variantId) === id(line.variant_id); })[0];
      if (!owned(line) && (!rule || id(line.product_id) !== id(config.productId))) return;
      result.relevant = true;
      var group = groups[token] || (groups[token] = { parents: [], gifts: [] });
      if (owned(line)) group.gifts.push(line);
      else if (rule && safeId(rule.planId) && safeId(rule.variantId) && safeId(config.productId) && id(line.product_id) === id(config.productId) && planId(line) === id(rule.planId) && line.quantity > 0 && line.original_price > 0) group.parents.push({ line: line, rule: rule });
    });
    var removes = [], updates = [], adds = [], invalidPrice = false;
    Object.keys(groups).forEach(function (token) {
      var group = groups[token];
      if (group.parents.length > 1) fail('Multiple trial parents share a gift request');
      var parent = group.parents[0];
      var expected = parent ? config.gifts[id(parent.rule.tier)] : [];
      if (!Array.isArray(expected) || (parent && (['8', '16'].indexOf(id(parent.rule.tier)) === -1 || expected.length !== (id(parent.rule.tier) === '8' ? 1 : 2) || new Set(expected.map(function (gift) { return id(gift.variantId); })).size !== expected.length))) fail('Gift configuration incomplete');
      var seen = {};
      group.gifts.forEach(function (line) {
        var match = expected.filter(function (gift) { return id(gift.variantId) === id(line.variant_id) && id(gift.productId) === id(line.product_id); })[0];
        var zero = line.original_price === 0 && line.final_price === 0 && line.final_line_price === 0 && !line.selling_plan_allocation;
        if (!match || !zero || seen[id(line.variant_id)]) {
          removes.push({ id: line.key, quantity: 0 });
          if (match && !zero) invalidPrice = true;
          return;
        }
        seen[id(line.variant_id)] = true;
        if (line.quantity !== 1 || id(line.properties._trial_gift_for) !== id(parent.line.variant_id) || line.properties._no_gifts !== 'true') {
          updates.push({ id: line.key, quantity: 1, properties: Object.assign({}, line.properties, { _no_gifts: 'true', _trial_gift_for: id(parent.line.variant_id) }) });
        }
      });
      expected.forEach(function (gift) {
        if (!safeId(gift.variantId) || !safeId(gift.productId) || typeof gift.handle !== 'string' || !gift.handle) fail('Invalid gift configuration');
        if (!seen[id(gift.variantId)]) adds.push({ gift: gift, marker: token, parent: id(parent.line.variant_id) });
      });
    });
    result.invalidPrice = invalidPrice;
    result.operation = removes.length ? { type: 'change', body: removes[0] } : updates.length ? { type: 'change', body: updates[0] } : adds.length ? { type: 'add', entry: adds[0] } : null;
    return result;
  }
  function preflight(gift) {
    return request('/products/' + encodeURIComponent(gift.handle) + '.js').then(function (product) {
      var variant = (product.variants || []).filter(function (item) { return id(item.id) === id(gift.variantId); });
      if (id(product.id) !== id(gift.productId) || product.handle !== gift.handle || variant.length !== 1 || !variant[0].available || variant[0].price !== 0 || product.requires_selling_plan !== false || variant[0].requires_selling_plan === true) fail('Gift unavailable');
    });
  }
  function write(operation) {
    if (operation.type === 'change') return request('/cart/change.js', operation.body);
    var entry = operation.entry;
    return preflight(entry.gift).then(function () {
      return request('/cart/add.js', { items: [{ id: Number(entry.gift.variantId), quantity: 1, properties: { _no_gifts: 'true', _trial_gift_request: entry.marker, _trial_gift_for: entry.parent } }] });
    });
  }
  function schedule(delay) {
    pending = true;
    render();
    if (active) { queued = true; return; }
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; sync(); }, delay == null ? 800 : delay);
  }
  function sync() {
    if (active) { queued = true; return active; }
    window.clearTimeout(timer); timer = null;
    if (inflight) { schedule(300); return Promise.resolve(status()); }
    pending = true; render();
    var merger = window.alTrialCartMerge, leased = false, changed = false, retry = false, readOk = false, readGeneration = mutationGeneration;
    active = readCart().then(function (cart) {
      readOk = true; inspected = readGeneration === mutationGeneration && inflight === 0;
      if (!inspected) { retry = true; return; }
      relevant = relevantCart(cart);
      if (!relevant) { error = ''; uncertain = false; invalidPriceLock = false; return; }
      return merger && typeof merger.whenIdle === 'function' ? merger.whenIdle() : undefined;
    }).then(function () {
      if (!inspected || !relevant) return;
      if (inflight) { retry = true; return; }
      if (!merger || typeof merger.beginGiftSync !== 'function' || typeof merger.endGiftSync !== 'function') fail('Cart coordinator unavailable');
      leased = merger.beginGiftSync();
      if (!leased) {
        if (++leaseRetries > 8) fail('Cart coordinator busy');
        retry = true; return;
      }
      leaseRetries = 0;
      var pass = function (count) {
        return readCart().then(function (cart) {
          relevant = relevantCart(cart);
          var result = analyse(cart);
          relevant = result.relevant;
          if (!result.operation) { if (invalidPriceLock) fail('A gift had an invalid price; reload and check the cart'); error = ''; uncertain = false; return; }
          if (typeof merger.giftSyncAllowed !== 'function' || !merger.giftSyncAllowed(cart)) fail('Cart changed before gift synchronization');
          if (uncertain) fail('Previous cart write is uncertain; automatic retry stopped');
          if (count >= 12) fail('Gift reconciliation did not settle');
          return write(result.operation).then(function () { changed = true; if (result.invalidPrice) { invalidPriceLock = true; uncertain = true; fail('A gift had an invalid price and was removed; please check the cart'); } return pass(count + 1); }, function (reason) { uncertain = true; throw reason; });
        });
      };
      return pass(0);
    }).catch(function (reason) {
      if (!readOk) inspected = false;
      error = reason && reason.message || 'Gift synchronization failed';
      console.warn('[al-trial-gift-lifecycle]', error);
    }).finally(function () {
      if (leased) merger.endGiftSync();
      active = null;
      if (!retry) leaseRetries = 0;
      pending = Boolean(retry || queued || inflight);
      render();
      if (changed) {
        document.dispatchEvent(new CustomEvent('al:trial-gifts-synced'));
        var drawer = document.querySelector('#g-cart-content');
        if (drawer && drawer.classList.contains('g-cart-open')) document.dispatchEvent(new Event('gOpenCart'));
        if (/^\/cart\/?$/.test(location.pathname) && !error && !window.alTrialMainCartMutations) {
          var cartUrl = new URL(location.href);
          if (cartUrl.searchParams.has('preview_theme_id') && window.Shopify && Shopify.theme && Shopify.theme.id) cartUrl.searchParams.set('preview_theme_id', id(Shopify.theme.id));
          cartUrl.hash = '';
          if (cartUrl.searchParams.has('preview_theme_id')) cartUrl.searchParams.set('_trial_cart_refresh', Date.now().toString());
          if (cartUrl.href === location.href) location.reload(); else location.assign(cartUrl.href);
        }
      }
      if (retry || queued) { queued = false; schedule(500); }
    });
    return active;
  }
  function hasHeader(input, init) {
    try { return new Headers(init && init.headers || input && input.headers || {}).has(header); } catch (_) { return false; }
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url || '';
    var observe = !hasHeader(input, init) && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (observe) { mutationGeneration++; inflight++; pending = true; inspected = false; render(); }
    var response;
    try { response = nativeFetch.apply(this, arguments); }
    catch (reason) { if (observe) { inflight--; mutationGeneration++; schedule(); } throw reason; }
    if (observe) response.then(function () { inflight--; mutationGeneration++; schedule(); }, function () { inflight--; mutationGeneration++; schedule(); });
    return response;
  };
  function blockDrawerMutation(event) {
    if (!mergeBlocked() || !event.target || !event.target.closest || !event.target.closest('#g-cart-content')) return;
    if (!event.target.closest('.g-ci-quantity-plus, .g-ci-quantity-minus, .g-remove, .g-quantity-option, .g-ci-sub-check, .g-variant-select')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    render();
  }
  document.addEventListener('click', blockDrawerMutation, true);
  document.addEventListener('change', blockDrawerMutation, true);
  function checkoutTarget(target) {
    return target && target.closest && target.closest('[name="checkout"], .g-cart-checkout, a[href*="/checkout"], [data-shopify="payment-button"]');
  }
  document.addEventListener('click', function (event) {
    if (!checkoutBlocked() || !checkoutTarget(event.target)) return;
    checkoutNoticeRequested = true; event.preventDefault(); event.stopImmediatePropagation(); render();
  }, true);
  document.addEventListener('submit', function (event) {
    if (!checkoutBlocked()) return;
    var form = event.target;
    if (!form || !(/\/checkout(?:\?|$)/.test(form.action || '') || checkoutTarget(event.submitter) || form.querySelector('[name="checkout"]'))) return;
    checkoutNoticeRequested = true; event.preventDefault(); event.stopImmediatePropagation(); render();
  }, true);
  if (typeof MutationObserver !== 'undefined') new MutationObserver(function(changes){if(changes.some(function(change){return Array.prototype.some.call(change.addedNodes,function(node){return node.nodeType===1 && (node.matches('shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.additional-checkout-buttons,.dynamic-checkout__content') || node.querySelector('shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.additional-checkout-buttons,.dynamic-checkout__content'));});})) render();}).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('al:trial-transaction-state', render);
  document.addEventListener('al:trial-cart-merged', function () { schedule(); });
  document.addEventListener('gOpenCart', function () { schedule(); });
  window.alTrialGiftLifecycle = { sync: sync, whenIdle: function idle() { return pending || active || timer || inflight ? Promise.resolve(active).then(function () { return new Promise(function (resolve) { window.setTimeout(resolve, 100); }); }).then(idle) : Promise.resolve(status()); }, get state() { return status(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  else schedule(0);
})();
